// eslint-disable-next-line
import { produce } from 'immer';

const INITIAL_VALUES = [];

export const SET_ANSWER = 'SET_ANSWER';

const answerReducer = (state = INITIAL_VALUES, action) =>
  produce(state, draft => {
    switch (action.type) {
      case SET_ANSWER: {
        return [...action.payload];
      }
      default:
        return draft;
    }
  });

export default answerReducer;
